// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading-m_pageLoading-JrbU3yLa"};